import SEO from '@/components/base/SEO';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturedArticles from './components/FeaturedArticles';
import CategoryGrid from './components/CategoryGrid';
import LatestNews from './components/LatestNews';
import { siteInfo } from '@/mocks/siteInfo';
import { Link } from 'react-router-dom';

const stats = [
  { value: '100+', label: '收录作品' },
  { value: '50万+', label: '月访问量' },
  { value: '10年+', label: '持续追踪' },
  { value: '12个', label: '内容分类' },
];

export default function Home() {
  const homepageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: siteInfo.name,
    url: siteInfo.url,
    description: siteInfo.description,
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${siteInfo.url}/search?q={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <ScrollToTop />
      <SEO
        title="首页"
        description={siteInfo.description}
        keywords={siteInfo.keywords}
        canonicalUrl={siteInfo.url}
        schemaData={homepageSchema}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <FeaturedArticles />
          <CategoryGrid />

          <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
            <div className="max-w-7xl mx-auto">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
                {stats.map((stat) => (
                  <div key={stat.label} className="p-6 bg-background-50 rounded-lg border border-background-200/70">
                    <div className="text-2xl md:text-3xl font-heading font-bold text-accent-500 mb-1">
                      {stat.value}
                    </div>
                    <div className="text-sm text-foreground-600">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <LatestNews />

          <section className="py-14 md:py-20 px-4 md:px-6">
            <div className="max-w-3xl mx-auto text-center relative">
              <div className="absolute inset-0 bg-accent-100/30 rounded-3xl -rotate-1"></div>
              <div className="relative bg-background-50 rounded-3xl border border-accent-200/50 p-8 md:p-12">
                <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-heart-add-line text-2xl text-accent-600"></i>
                </div>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
                  加入粉丝社区
                </h2>
                <p className="text-foreground-600 leading-relaxed mb-8 max-w-lg mx-auto">
                  加入大桥未久官方粉丝专区，获取最新资讯、独家内容和粉丝专属福利。与全球华人粉丝一起，分享你对大桥未久的喜爱。
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                  <Link
                    to="/category/all"
                    className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white px-6 py-3 rounded-full text-sm font-medium transition-all whitespace-nowrap"
                  >
                    <i className="ri-film-line"></i>
                    开始探索作品
                  </Link>
                  <Link
                    to="/about"
                    className="inline-flex items-center gap-2 bg-secondary-100 hover:bg-secondary-200 text-foreground-700 px-6 py-3 rounded-full text-sm font-medium transition-all whitespace-nowrap"
                  >
                    <i className="ri-information-line"></i>
                    了解更多
                  </Link>
                </div>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}